<div class="py-2 px-2 py-md-5 px-md-5">
    <div class="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-3">
        <app-dashboard-card [imageName]="'service-orders.webp'" [buttonIcon]="'fa-regular fa-rectangle-list'"
                            [buttonName]="'Zgłoszenia serwisowe'" [buttonLink]="'service-orders'"></app-dashboard-card>
        <app-dashboard-card *ngIf="authService.user.type !== 'user'" [imageName]="'intercom-codes.webp'"
                            [buttonIcon]="'fa-solid fa-keyboard'"
                            [buttonName]="'Kody domofonów'" [buttonLink]="'intercom-codes'"></app-dashboard-card>
        <app-dashboard-card *ngIf="authService.user.type !== 'user'" [imageName]="'working-times.webp'"
                            [buttonIcon]="'fa-solid fa-clock-rotate-left'"
                            [buttonName]="'Czas pracy'" [buttonLink]="'working-times'"></app-dashboard-card>
        <app-dashboard-card *ngIf="authService.user.type === 'admin'" [imageName]="'users.webp'"
                            [buttonIcon]="'fa-solid fa-user-group'"
                            [buttonName]="'Użytkownicy'" [buttonLink]="'users'"></app-dashboard-card>
        <app-dashboard-card *ngIf="authService.user.type === 'admin'" [imageName]="'deposit.webp'"
                            [buttonIcon]="'fa-solid fa-money-check-dollar'"
                            [buttonName]="'Depozyty'" [buttonLink]="'deposits'"></app-dashboard-card>
        <app-dashboard-card *ngIf="authService.user.type !== 'user'" [imageName]="'tasks.webp'"
                            [buttonIcon]="'fa-solid fa-clipboard-check'"
                            [buttonName]="'Zadania'" [buttonLink]="'tasks'"></app-dashboard-card>
        <app-dashboard-card *ngIf="authService.user.type === 'admin'" [imageName]="'cars.webp'"
                            [buttonIcon]="'fa-solid fa-car'"
                            [buttonName]="'Samochody'" [buttonLink]="'cars'"></app-dashboard-card>
    </div>
</div>
